import { asyncRoutes, constantRoutes } from '@/router'
import PaymentChildrenMenu from '@/utils/paymentChildrenMenu';

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

/**
 * Use path to determine if the current user has permission
 * @param menus
 * @param route
 */
function hasPermissionByMenu(menus, route) {
  return menus.some(menu => route.path == menu)
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param menus
 */
export function filterAsyncRoutesByMenus(routes, menus) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermissionByMenu(menus, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutesByMenus(tmp.children, menus)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: constantRoutes,
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      let accessedRoutes
      if (roles.includes('admin')) { // 管理员的话 直接全给路由
        accessedRoutes = constantRoutes || []
      } else { // 不是的话
        accessedRoutes = filterAsyncRoutes(constantRoutes, roles)
      }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },

  generateRoutesByMenus({ commit, rootState }, menus) {
    return new Promise(async resolve => {
      let accessedRoutes = filterAsyncRoutesByMenus(asyncRoutes, menus)
      // 动态加载付款单子菜单
      try {
        const dynamicMenuPaths = await PaymentChildrenMenu.addDynamicMenus(accessedRoutes, menus)
        // 将动态菜单路径添加到菜单列表中
        if (dynamicMenuPaths.length > 0) {
          const updatedMenus = [...menus, ...dynamicMenuPaths]
          // 更新菜单列表
          if (rootState.user) {
            commit('user/SET_MENULIST', updatedMenus, { root: true })
          }
        }
      } catch (error) {
        console.error('加载动态菜单失败:', error)
      }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
